/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileDimensionRisk } from './RiskProfileDimensionRisk';
import {
  RiskProfileDimensionRiskFromJSON,
  RiskProfileDimensionRiskFromJSONTyped,
  RiskProfileDimensionRiskToJSON,
} from './RiskProfileDimensionRisk';

/**
 *
 * @export
 * @interface PaginatedRiskProfileDimensionRiskList
 */
export interface PaginatedRiskProfileDimensionRiskList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskProfileDimensionRiskList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileDimensionRiskList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileDimensionRiskList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskProfileDimensionRisk>}
   * @memberof PaginatedRiskProfileDimensionRiskList
   */
  results: Array<RiskProfileDimensionRisk>;
}

/**
 * Check if a given object implements the PaginatedRiskProfileDimensionRiskList interface.
 */
export function instanceOfPaginatedRiskProfileDimensionRiskList(
  value: object,
): value is PaginatedRiskProfileDimensionRiskList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskProfileDimensionRiskListFromJSON(json: any): PaginatedRiskProfileDimensionRiskList {
  return PaginatedRiskProfileDimensionRiskListFromJSONTyped(json, false);
}

export function PaginatedRiskProfileDimensionRiskListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskProfileDimensionRiskList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskProfileDimensionRiskFromJSON),
  };
}

export function PaginatedRiskProfileDimensionRiskListToJSON(value?: PaginatedRiskProfileDimensionRiskList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskProfileDimensionRiskToJSON),
  };
}
